import { Discussion } from "@/models/Discussions"
import { useState } from "react"
import { DiscussionBody } from "./DiscussionBody"
import { AddComment } from "@/components/designSystem/Discussions/components/Comment/AddComment"
import { DISCUSSION_STYLES } from "@/components/designSystem/Discussions/utils"
import { useDiscussionHover } from "@/hooks/useDiscussionHover"

interface Props {
  selectedDiscussion: Discussion
  discussionNumber: number
  isResolved: boolean
  crId: string
  commitSha: string
}

export const ExpandedDiscussion = ({ selectedDiscussion, discussionNumber, isResolved, crId, commitSha }: Props) => {
  const hoverProps = useDiscussionHover(selectedDiscussion)
  const [areAllCommentsExpanded, setAreAllCommentsExpanded] = useState(false)

  return (
    <div
      id={selectedDiscussion.id}
      className={DISCUSSION_STYLES}
      data-discussion-number={discussionNumber}
      {...hoverProps}
    >
      <DiscussionBody
        comments={selectedDiscussion?.comments}
        discussion={selectedDiscussion}
        isResolved={isResolved}
        id={selectedDiscussion.id}
        areAllCommentsExpanded={areAllCommentsExpanded}
        setAreAllCommentsExpanded={setAreAllCommentsExpanded}
      />

      {(!isResolved || areAllCommentsExpanded) && (
        <AddComment discussion={selectedDiscussion} crId={crId} commitSha={commitSha} />
      )}
    </div>
  )
}
